import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import moment from "moment";
import { createMeeting, editMeeting } from "../../api/meetings";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import { decryptData } from "../../utils/helper";
import momenttimezone from "moment-timezone"; // Import moment-timezone

const ViewMeeting = ({ show, getMeetings, onHide, isLoading, selectedEvent,  teamMembers = [], setIsLoading, selectedDate, setShowOffcanvas }) => {
  const dispatch = useDispatch();
  let token = useSelector(state => state.userReducer.token);
  let user = useSelector((state) => state?.userReducer?.user);
  const disabledStatus = selectedEvent?.teamMembers.filter((member) => user?._id === member?.userId?._id)?.[0]?.status;
  const isAdmin =  selectedEvent?.createdBy?._id === user?._id;
  const userTimezone = momenttimezone.tz.guess(); // Automatically detect the user's timezone

  const formik = useFormik({
    initialValues: {
      eventTitle: "",
      fromTime: "",
      toTime: "",
      teamMembers: [],
      patient: null,
      description: "",
      createdBy: null
    },
    onSubmit: async (values) => {
      const eventDate = moment(selectedEvent?.start).format("YYYY-MM-DD");

      const eventData = {
        ...values,
        date: moment.utc(selectedEvent?.start), // Ensure the date is UTC
       fromTime: values.fromTime
         ? moment
             .tz(eventDate + " " + values.fromTime, userTimezone) // Combine the event date and user time
             .utc() // Convert to UTC
             .format() // Store in ISO 8601 format (UTC)
         : "",
       toTime: values.toTime
         ? moment
             .tz(eventDate + " " + values.toTime, userTimezone) // Combine the event date and user time
             .utc() // Convert to UTC
             .format() // Store in ISO 8601 format (UTC)
         : "",
        teamMembers: values.teamMembers.map(member => ({
          userId: member.value,
          status: "Pending"
        }))
      };

        let res;
        try {
          setIsLoading(true);
          if (selectedEvent?.eventId) {
            res = await editMeeting({ values: {...eventData, eventId : selectedEvent?.eventId}, dispatch, token });
          }else{
          res = await createMeeting({ values: {...eventData, organizationId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId")}, dispatch, token });
          }
          if (res?.status == "SUCCESS") {
              setIsLoading(false);
              success(res?.message);
              onHide();
              getMeetings();
              formik.resetForm();
          }else{
            setIsLoading(false);
            failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
    }
  });

  useEffect(() => {
    if (selectedEvent) {
      const selectedTeamMemberIds = selectedEvent?.teamMembers?.map((member) => member?.userId?._id);
      const filteredTeamMembers = teamMembers
        .filter((member) => selectedTeamMemberIds?.includes(member.value))
        .map((member) => ({
          value: member?.value,
          label: member?.label
        }));

      const startDate = momenttimezone.tz(selectedEvent?.start, userTimezone); // Convert to the user's local timezone
      const endDate = momenttimezone.tz(selectedEvent?.end, userTimezone); // Convert to the user's local timezone

      formik.setValues({
        eventTitle: selectedEvent.title || "",
        date: startDate.format("YYYY-MM-DD"),
        fromTime: startDate.format("HH:mm"), // Display time in the user's local timezone
        toTime: endDate.format("HH:mm"), // Display time in the user's local timezone
        teamMembers: filteredTeamMembers || [],
        patient: selectedEvent?.patient?._id?._id || null,
        description: selectedEvent.description || "",
        createdBy: selectedEvent?.createdBy
      });
    } else {
      formik.resetForm();
    }
  }, []);

const handleStatusMeeting = async(status)=>{
    const eventData = {
      teamMembers: [
        // Update the selected user's status
        ...selectedEvent.teamMembers
          .filter((member) => member.userId && member.userId._id === user?._id)
          .map((member) => ({
            userId: member.userId._id,
            status: status
          })),
        // Keep the other team members unchanged
        ...selectedEvent.teamMembers
          .filter((member) => member.userId && member.userId._id !== user?._id).map((member) => ({
            userId: member.userId._id,
            status: member.status
          }))
      ]
    };
        let res;
        try {
          setIsLoading(true);
          res = await editMeeting({ values: {...eventData, eventId : selectedEvent?.eventId}, dispatch, token });
          if (res?.status == "SUCCESS") {
              setIsLoading(false);
              success(res?.message);
              onHide();
              getMeetings();
              formik.resetForm();
          }else{
            setIsLoading(false);
            failed(res?.message);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
};
  return (
    <Modal isOpen={show} toggle={onHide} size="lg">
        {isLoading ? (<Loader/>) : null}
        <ModalHeader className="assign_blk p-3" toggle={onHide}>
        <span className="title-meeting">
          View Meeting -{" "}
        </span>
        <span style={{ fontSize: "20px" }}>
          {moment(selectedEvent?.start || selectedDate).format("dddd, MMMM DD, YYYY")}
        </span>
        {isAdmin && (
          <i
            className="fa-solid fa-pen"
            style={{ marginLeft: "50px", cursor: "pointer" }}
            onClick={() => {
              onHide();
              setShowOffcanvas(true);
            }}
          />
        )}
      </ModalHeader>
      <form onSubmit={formik.handleSubmit}>
        <ModalBody style={{padding:"30px"}}>
          <Row><Col md={12} className="mb-3">
            <div className="d-flex justify-content-between">
            <div><h5>{formik.values.eventTitle} <span> - <b>{moment(formik.values.fromTime, "HH:mm").format("h:mmA")}- {moment(formik.values.toTime, "HH:mm").format("h:mmA")}</b></span></h5></div>
             {!isAdmin && <div>
             <button type="button" className="accept-btn" disabled={disabledStatus === "Accepted"} onClick={()=>handleStatusMeeting("Accepted")}>{disabledStatus === "Accepted" ? "Accepted" : "Accept"}</button>
             <button type="button" className="decline-btn"  disabled={disabledStatus === "Declined"}onClick={()=>handleStatusMeeting("Declined")}>Decline</button>
             </div>}
            </div>
            </Col></Row>
          <div className="mt-2">
          <h4>Participants</h4>
          {
              selectedEvent?.createdBy && (
                <Row key="patient-status">
                  <div className="mt-3">
                    <h6>
                    <i className={`fa fa-user-tie text-primary`} />
                     {"  "}{selectedEvent?.createdBy?.firstName + "  "+selectedEvent?.createdBy?.lastName} - Organizer
                    </h6>
                  </div>
                </Row>
              )
            }
            {
              selectedEvent?.eventId && selectedEvent.teamMembers.map(item => {
                let iconClass, colorClass;

                // Determine icon and color class based on status for team members
                if (item.status === 'Accepted') {
                  iconClass = 'fa-check-circle';
                  colorClass = 'text-success';
                } else if (item.status === 'Declined') {
                  iconClass = 'fa-times-circle';
                  colorClass = 'text-danger';
                } else {
                  iconClass = 'fa-question-circle';
                  colorClass = 'text-warning';
                }

                return (
                  <Row key={item._id}>
                    <div className="mt-3">
                      <h6>
                        <i className={`fa ${iconClass} ${colorClass}`} />
                        {"  "}{item.userId?.firstName + " " + item.userId?.lastName}
                      </h6>
                    </div>
                  </Row>
                );
              })
            }

            {/* Render Patient Status with icon */}
            {
              selectedEvent?.patient?._id && (
                <Row key="patient-status">
                  <div className="mt-3">
                    <h6>
                      {/* Patient Status Icon */}
                      <i className={`fa ${selectedEvent.patient.status === 'Accepted' ? 'fa-check-circle text-success' : selectedEvent.patient.status === 'Declined' ? 'fa-times-circle text-danger' : 'fa-question-circle text-warning'}`} />
                     {"  "}{selectedEvent?.patient?._id?.name[0]?.text && decryptData(selectedEvent?.patient?._id?.name[0]?.text)} - Patient
                    </h6>
                  </div>
                </Row>
              )
            }
            </div>
          <Row style={{marginTop:"50px"}}>
            <Col md={12}>
              <label className="w-form-label">Add Description</label>
              <textarea
                name="description"
                rows={4}
                className="form-control"
                value={formik.values.description}
                onChange={formik.handleChange}
                placeholder="Add a description"
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" type="submit">
            {selectedEvent?._id ? "Update" : "Save"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ViewMeeting;
